export default __webpack_public_path__ + "static/city-pattern-53b200aba3843e43ec22b03a364261a2.svg";